module.exports = __webpack_public_path__ + "img/use_zh-CN.425a0b71.png";